var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 3.20841H7.79167C7.54855 3.20841 7.31539 3.11184 7.14349 2.93993C6.97158 2.76802 6.875 2.53486 6.875 2.29175V0.916748",
    stroke: "#8BA3CB",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12492 8.25008C3.8818 8.25008 3.64865 8.1535 3.47674 7.9816C3.30483 7.80969 3.20825 7.57653 3.20825 7.33341V1.83341C3.20825 1.5903 3.30483 1.35714 3.47674 1.18523C3.64865 1.01333 3.8818 0.916748 4.12492 0.916748H7.33325L9.16659 2.75008V7.33341C9.16659 7.57653 9.07001 7.80969 8.8981 7.9816C8.72619 8.1535 8.49303 8.25008 8.24992 8.25008H4.12492Z",
    stroke: "#8BA3CB",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 3.4834V9.35006C1.375 9.54456 1.45226 9.73108 1.58979 9.86861C1.72732 10.0061 1.91384 10.0834 2.10833 10.0834H6.6",
    stroke: "#8BA3CB",
    strokeWidth: 1.13636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5cdb825f0a1d01cd88763d78473fba07.svg";
export { ForwardRef as ReactComponent };